__turbopack_context__.v({
  "link": "SocialItem-module-scss-module__M0zyHW__link",
  "socialItem": "SocialItem-module-scss-module__M0zyHW__socialItem",
});
